// extracted by mini-css-extract-plugin
export default {"header":"ap2XTp_K","title":"qI1HI42f","feedbackButton":"_7FEIf7K","description":"tncRFZLr","descriptionText":"eUbBjfGq","titleIcon":"LPDuoMti"};